// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Mycalendar.css */
.calendar-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 100vh;
    margin: 0px;
    padding: 0px;
    position: relative;
    background-color: #bedde2;
}

.calendar {
    width: 100%;
    flex-grow: 1;
    
    z-index: 1;
    background-color: aliceblue;
}

.rbc-event:hover {
    opacity: 1; /* Make it fully opaque on hover */
    box-shadow: 0 4px 8px rgba(0,0,0,0.3); /* Larger shadow for pop effect */
    transform: scale(1.02); /* Slight increase in size */
  }

  .rbc-month-header {
    background-color: #9ba1b857;
  }
  
  .rbc-toolbar {
    background-color: #bedde2;
    margin: 5px 5px 5px 5px;
    border-width: 2px 2px 2px 2px;
    border-color: #216ba5;
    border-style: solid;
  }
  .rbc-toolbar button {
    color: #272726ad;
  }
  .rbc-toolbar button.rbc-active {
    color: #1d5d90;
  }
  .rbc-btn-group {
    background-color: white;
    display: inline-block;
    white-space: normal;
  }
  .header-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 0 20px; 
    width: 100%;
  }
  
  .logo-welcome-container {
    display: flex;
    align-items: center;
  }
  
  .logo {
    height: 80px; /* Adjust size as needed */
    margin-right: 100px; /* Space between logo and welcome message */
  }
  
  .welcome-message {
    font-size: 1.2em; /* Adjust size as needed */
  }
  
  .buttons-container {
    display: flex;
    align-items: center;
  }
  
  .header-button {
    margin-left: 10px; /* Space between buttons */
    /* Add additional button styling here */
  }
  
  .CalButtons {
    width: 100%;
    padding: 15px;
    background: #0c3274;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    margin-top: 10px;
    transition: background-color 0.3s ease;
    height: 50px;
  }
  
  .CalButtons:hover {
    background-color: #272726;
  }
  
  .CalButtons:focus {
    outline: none;
    box-shadow: 0 0 8px rgba(0, 86, 179, 0.2);
  }

  @media (max-width: 768px) {
    .header-container {
      flex-direction: column;
    }
  
    .logo-welcome-container {
      margin-bottom: 10px; /* Add some space between the logo/welcome message and the buttons */
    }
  
    .buttons-container {
      flex-direction: row;
      align-items: flex-start;
    }
  
    .header-button {
      margin-left: 0;
      margin-bottom: 5px; /* Stack the buttons with space between */
    }
  
    .logo {
      height: 50px; /* Adjust size as needed */
    }
  
    .welcome-message {
      font-size: 0.9em; /* Adjust font size as needed */
    }
  }
  
  /* This will apply when the device width is 480px or less */
  @media (max-width: 480px) {
    .header-container {
      padding: 0 10px; /* Less padding on very small screens */
    }
    
    .header {
      display: flex;
      flex-direction: column;
      align-items: center;
      z-index: 2;
      margin: 0%;
  }

    .logo {
      height: 40px; /* Smaller logo for very small screens */
    }
  
    .welcome-message {
      font-size: 0.8em; /* Smaller text for very small screens */
    }
    .buttons-container {
        display: flex;
        align-items: center;
      }
      
      .header-button {
        margin-left: 10px; /* Space between buttons */
        /* Add additional button styling here */
      }

      .CalButtons {
        width: 100%;
        padding: 8px;
        background: #0c3274;
        color: white;
        border: none;
        border-radius: 4px;
        cursor: pointer;
        margin-top: 10px;
        transition: background-color 0.3s ease;
        height: 36px;
      }
      
      .CalButtons:hover {
        background-color: #272726;
      }
      
      .CalButtons:focus {
        outline: none;
        box-shadow: 0 0 8px rgba(0, 86, 179, 0.2);
      }
  }`, "",{"version":3,"sources":["webpack://./src/pages/calendar/MyCalendar.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;IACb,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,YAAY;;IAEZ,UAAU;IACV,2BAA2B;AAC/B;;AAEA;IACI,UAAU,EAAE,kCAAkC;IAC9C,qCAAqC,EAAE,iCAAiC;IACxE,sBAAsB,EAAE,4BAA4B;EACtD;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,yBAAyB;IACzB,uBAAuB;IACvB,6BAA6B;IAC7B,qBAAqB;IACrB,mBAAmB;EACrB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,cAAc;EAChB;EACA;IACE,uBAAuB;IACvB,qBAAqB;IACrB,mBAAmB;EACrB;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;IACf,WAAW;EACb;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,YAAY,EAAE,0BAA0B;IACxC,mBAAmB,EAAE,2CAA2C;EAClE;;EAEA;IACE,gBAAgB,EAAE,0BAA0B;EAC9C;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,iBAAiB,EAAE,0BAA0B;IAC7C,uCAAuC;EACzC;;EAEA;IACE,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,sCAAsC;IACtC,YAAY;EACd;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,aAAa;IACb,yCAAyC;EAC3C;;EAEA;IACE;MACE,sBAAsB;IACxB;;IAEA;MACE,mBAAmB,EAAE,oEAAoE;IAC3F;;IAEA;MACE,mBAAmB;MACnB,uBAAuB;IACzB;;IAEA;MACE,cAAc;MACd,kBAAkB,EAAE,yCAAyC;IAC/D;;IAEA;MACE,YAAY,EAAE,0BAA0B;IAC1C;;IAEA;MACE,gBAAgB,EAAE,+BAA+B;IACnD;EACF;;EAEA,2DAA2D;EAC3D;IACE;MACE,eAAe,EAAE,uCAAuC;IAC1D;;IAEA;MACE,aAAa;MACb,sBAAsB;MACtB,mBAAmB;MACnB,UAAU;MACV,UAAU;EACd;;IAEE;MACE,YAAY,EAAE,wCAAwC;IACxD;;IAEA;MACE,gBAAgB,EAAE,wCAAwC;IAC5D;IACA;QACI,aAAa;QACb,mBAAmB;MACrB;;MAEA;QACE,iBAAiB,EAAE,0BAA0B;QAC7C,uCAAuC;MACzC;;MAEA;QACE,WAAW;QACX,YAAY;QACZ,mBAAmB;QACnB,YAAY;QACZ,YAAY;QACZ,kBAAkB;QAClB,eAAe;QACf,gBAAgB;QAChB,sCAAsC;QACtC,YAAY;MACd;;MAEA;QACE,yBAAyB;MAC3B;;MAEA;QACE,aAAa;QACb,yCAAyC;MAC3C;EACJ","sourcesContent":["/* Mycalendar.css */\n.calendar-container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    height: 100vh;\n    margin: 0px;\n    padding: 0px;\n    position: relative;\n    background-color: #bedde2;\n}\n\n.calendar {\n    width: 100%;\n    flex-grow: 1;\n    \n    z-index: 1;\n    background-color: aliceblue;\n}\n\n.rbc-event:hover {\n    opacity: 1; /* Make it fully opaque on hover */\n    box-shadow: 0 4px 8px rgba(0,0,0,0.3); /* Larger shadow for pop effect */\n    transform: scale(1.02); /* Slight increase in size */\n  }\n\n  .rbc-month-header {\n    background-color: #9ba1b857;\n  }\n  \n  .rbc-toolbar {\n    background-color: #bedde2;\n    margin: 5px 5px 5px 5px;\n    border-width: 2px 2px 2px 2px;\n    border-color: #216ba5;\n    border-style: solid;\n  }\n  .rbc-toolbar button {\n    color: #272726ad;\n  }\n  .rbc-toolbar button.rbc-active {\n    color: #1d5d90;\n  }\n  .rbc-btn-group {\n    background-color: white;\n    display: inline-block;\n    white-space: normal;\n  }\n  .header-container {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n    padding: 0 20px; \n    width: 100%;\n  }\n  \n  .logo-welcome-container {\n    display: flex;\n    align-items: center;\n  }\n  \n  .logo {\n    height: 80px; /* Adjust size as needed */\n    margin-right: 100px; /* Space between logo and welcome message */\n  }\n  \n  .welcome-message {\n    font-size: 1.2em; /* Adjust size as needed */\n  }\n  \n  .buttons-container {\n    display: flex;\n    align-items: center;\n  }\n  \n  .header-button {\n    margin-left: 10px; /* Space between buttons */\n    /* Add additional button styling here */\n  }\n  \n  .CalButtons {\n    width: 100%;\n    padding: 15px;\n    background: #0c3274;\n    color: white;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n    margin-top: 10px;\n    transition: background-color 0.3s ease;\n    height: 50px;\n  }\n  \n  .CalButtons:hover {\n    background-color: #272726;\n  }\n  \n  .CalButtons:focus {\n    outline: none;\n    box-shadow: 0 0 8px rgba(0, 86, 179, 0.2);\n  }\n\n  @media (max-width: 768px) {\n    .header-container {\n      flex-direction: column;\n    }\n  \n    .logo-welcome-container {\n      margin-bottom: 10px; /* Add some space between the logo/welcome message and the buttons */\n    }\n  \n    .buttons-container {\n      flex-direction: row;\n      align-items: flex-start;\n    }\n  \n    .header-button {\n      margin-left: 0;\n      margin-bottom: 5px; /* Stack the buttons with space between */\n    }\n  \n    .logo {\n      height: 50px; /* Adjust size as needed */\n    }\n  \n    .welcome-message {\n      font-size: 0.9em; /* Adjust font size as needed */\n    }\n  }\n  \n  /* This will apply when the device width is 480px or less */\n  @media (max-width: 480px) {\n    .header-container {\n      padding: 0 10px; /* Less padding on very small screens */\n    }\n    \n    .header {\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      z-index: 2;\n      margin: 0%;\n  }\n\n    .logo {\n      height: 40px; /* Smaller logo for very small screens */\n    }\n  \n    .welcome-message {\n      font-size: 0.8em; /* Smaller text for very small screens */\n    }\n    .buttons-container {\n        display: flex;\n        align-items: center;\n      }\n      \n      .header-button {\n        margin-left: 10px; /* Space between buttons */\n        /* Add additional button styling here */\n      }\n\n      .CalButtons {\n        width: 100%;\n        padding: 8px;\n        background: #0c3274;\n        color: white;\n        border: none;\n        border-radius: 4px;\n        cursor: pointer;\n        margin-top: 10px;\n        transition: background-color 0.3s ease;\n        height: 36px;\n      }\n      \n      .CalButtons:hover {\n        background-color: #272726;\n      }\n      \n      .CalButtons:focus {\n        outline: none;\n        box-shadow: 0 0 8px rgba(0, 86, 179, 0.2);\n      }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
